type SupportedCurrency = 'XOF' | 'XAF' | 'GNF';

const currencyLabels: Record<SupportedCurrency, string> = {
  XOF: 'FCFA',
  XAF: 'FCFA',
  GNF: 'GNF',
};

/**
 * Montant groupé SANS libellé de devise (ex. « 5 000 »).
 * À utiliser quand le suffixe de devise est rendu séparément (gros affichages POS).
 */
export function formatAmount(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true,
  }).format(amount);
}

/**
 * Normalise un prix venant de l'API (number, ou chaîne décimale « 5000.00 » du
 * cast Laravel `decimal:2`) en chaîne de CHIFFRES ENTIERS pour les champs de
 * saisie XOF (devise sans sous-unité). Évite que les décimales « .00 » soient
 * concaténées comme des zéros et gonflent le montant ×100 à l'affichage.
 */
export function toPriceInput(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  return Number.isFinite(n) ? String(Math.round(n)) : '';
}

export function formatCurrency(amount: number, currency: SupportedCurrency): string {
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true,
  });

  const formatted = formatter.format(amount);
  return `${formatted} ${currencyLabels[currency]}`;
}

export function formatCompactCurrency(amount: number, currency: SupportedCurrency): string {
  const abs = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';
  const label = currencyLabels[currency];

  if (abs >= 1_000_000) {
    const value = abs / 1_000_000;
    const formatted = value % 1 === 0 ? String(value) : value.toFixed(1).replace('.', ',');
    return `${sign}${formatted}M ${label}`;
  }

  if (abs >= 10_000) {
    const value = abs / 1_000;
    const formatted = value % 1 === 0 ? String(value) : value.toFixed(1).replace('.', ',');
    return `${sign}${formatted}K ${label}`;
  }

  return formatCurrency(amount, currency);
}
